<template>
  <searches-groups-list-page
      resource-name="tag_library"
      :is-initiated="tagsSearchesAreInitiated"
      :hide-filters="true"
      :data="tagsSearchesData"
      :no-data="tagsSearchesNoData"
      :all-loaded="tagsSearchesAllLoaded"
      can-load-more-string="tagsSearchesCanLoadMore"
      :is-busy="tagsSearchesAreBusy"
  />
</template>

<script>
// Components
import SearchesGroupsListPage from "../../components/boolean-search/SearchesGroupsListPage.vue";

// Mixins
import computedQueries from "../../mixins/boolean-search/computedQueries";

export default {
  name: "tags-searches-list",

  mixins: [ computedQueries ],

  components: {
    SearchesGroupsListPage,
  }
}
</script>